import React, { FC } from "react";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

type Props = Omit<FontAwesomeIconProps, "icon">;

export const ChevronRight: FC<Props> = (props) => (
  <FontAwesomeIcon icon={faChevronRight} {...props} />
);
